import { gql } from '@apollo/client'
import type { DocumentNode } from 'graphql'
import type { FilterQuery, QueryOptions, User } from '@ztechapps/common.contract'
import { buildUserSearchFilter } from '@ztechapps/common.utils'

//region GraphQL query
export const getContactListQuery: DocumentNode = gql`
  query getContactList($filter: JSON, $options: JSON) {
    getContactList(filter: $filter, options: $options) {
      _id
      type
      status
      phone
      profile {
        _id
        name
        email
        picture
      }
      company {
        _id
        name
        domain
      }
    }
  }
`

//endregion

export type UseContactSelectResult = {
  dataLoadOptions: ({ filter }: { filter?: FilterQuery<User> }) => {
    query: DocumentNode
    resultFieldName: string
    filter: ({ input }: { input: any }) => FilterQuery<User>
    options: () => QueryOptions<User>
  }
}

export const useContactSelect = (): UseContactSelectResult => {
  const dataLoadOptions = ({ filter }: { filter?: FilterQuery<User> } = {}) => ({
    query: getContactListQuery,
    resultFieldName: 'getContactList',
    filter: ({ input }: { input: any }) => ({
      ...buildUserSearchFilter(input),
      ...filter,
    }),
    options: () => ({
      sort: { 'company.name': 1 as const },
    }),
  })

  return { dataLoadOptions }
}
